import React from 'react';

export interface LifecycleDelivery {
  purpose: string;
  status: string;
  needs_review?: boolean;
  delayed?: boolean;
}
const purposes: Record<string, string> = {
  contribution_received: 'Recording update',
  voice_ready: 'Voice ready email',
  build_attention: 'Recording help email',
  consent_management: 'Sharing management email',
};
const states: Record<string, string> = {
  queued: 'Queued', submitted: 'Sent', delivered: 'Delivered', failed: 'Could not deliver',
};
export default function DeliveryLifecycleStatus({ deliveries = [] }: { deliveries?: LifecycleDelivery[] }) {
  return <>{deliveries.filter(d => purposes[d.purpose] && states[d.status]).map(d => (
    <small key={d.purpose} aria-label={`${purposes[d.purpose]} status`}>
      {purposes[d.purpose]}: {d.needs_review ? 'Delivery needs review' : d.delayed ? 'Temporarily delayed' : states[d.status]}
    </small>
  ))}</>;
}
